module.exports = __webpack_public_path__ + "img/img59.fd436817.jpg";